import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import AppContext from "../../container/context";
import Form from "../../components/form";

export default function NovoChamado({ history, location }) {
  const { notification } = useContext(AppContext);
  const [dados, setDados] = useState({
    titulo: "",
    descricao: "",
    responsavel: 0,
    URL: "",
  });
  const [responsaveis, setResponsaveis] = useState([]);

  useEffect(() => {
    carregarUsuarios();
  }, []);

  const carregarUsuarios = () => {
    api
      .get("grupos/membros", { grupoCodIdentificador: "ADMIN_SISTEMA" })
      .then((res) => {
        setResponsaveis(res);
      });
  };

  const inserirChamado = (form) => {
    setDados(form);

    const data = new FormData();

    data.append("titulo", form.titulo);
    data.append("responsavelUsuarioId", form.responsavelUsuarioId);
    data.append("descricao", form.descricao);
    data.append("URL", form.URL);

    if (form.anexo && form.anexo[0]) {
      data.append("anexo", form.anexo[0]);
    }

    // for (const value of data.values()) {
    //   console.log("data", value);
    // }

    api
      .put("chamados/inserir", data)
      .then((res) => {
        notification("success", "Chamado inserido!");
        setDados({});
        history.push(`/app/chamados`);
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Titulo inválido");
          case 2:
            return notification("error", "Descrição inválida");
          case 3:
            return notification("error", "Usuário responsável inválido");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const fChamado = {
    title: "Solicitação",
    form: {
      titulo: {
        label: "Título",
        type: "text",
        value: dados.titulo,
      },
      responsavelUsuarioId: {
        label: "Responsável",
        value: dados.responsavelUsuarioId,
        type: "select",
        emptyItem: true,
        array: {
          data: responsaveis,
          value: "usuarioId",
          desc: "usuarioNome",
        },
      },
      descricao: {
        label: "Descrição",
        type: "textarea",
        value: dados.descricao,
      },
      URL: {
        label: "URL/link da tela da ocorrência",
        type: "text",
        value: dados.URL,
      },
      anexo: {
        label: "Anexo",
        type: "file",
        accept: "image/png, image/gif, image/jpeg",
      },
    },

    submit: {
      label: "salvar",
      action: inserirChamado,
    },

    history,
    close: true,
  };

  return (
    <div>
      <Form formData={fChamado} />
    </div>
  );
}
